import React, { Component } from 'react';
import * as uuid from 'uuid';

class BooleanField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      localValue: props.defaultValue,
    };

    this.radioName = uuid.v4();
    this.onRadioChange = (e) => this.props.onValue(e.target.value === 'true');
    this.onUnselect = () => this.props.onValue('');
  }

  canBeUnselected() {
    return (
      !this.props.disabled && !this.props.required && this.isValuePresent()
    );
  }

  isValuePresent() {
    return typeof this.props.value === 'boolean';
  }

  includedProps(booleanValue) {
    const { value, disabled, defaultValue, required } = this.props;

    let props = {
      value: booleanValue,
      required: required,
      disabled: disabled,
      name: this.radioName,
    };

    if (this.props.onValue) {
      props.onChange = this.onRadioChange;

      if (booleanValue === true) {
        props.checked = !!value && value !== 'false' && !disabled;
      } else {
        props.checked =
          (!value && this.isValuePresent()) || (!!value && value === 'false');
      }
    } else {
      props.defaultChecked = defaultValue === booleanValue;
      props.onChange = (e) =>
        this.setState({ localValue: e.target.value === 'true' });
    }

    return props;
  }

  render() {
    const { value, name } = this.props;

    return (
      <div className='booleanComponent'>
        <input
          readOnly
          name={name}
          type='hidden'
          value={this.props.onValue ? value : this.state.localValue}
        />
        <label>
          <input
            type='radio'
            {...this.includedProps(true)}
          />
          Enabled
        </label>
        <label>
          <input
            type='radio'
            {...this.includedProps(false)}
          />
          Disabled
        </label>

        {this.canBeUnselected() && (
          <a
            className='ui small button unselect io-form-button'
            onClick={this.onUnselect}
          >
            <i className='remove icon'></i>Unselect
          </a>
        )}
      </div>
    );
  }
}

module.exports = BooleanField;
